import { Theme, useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { Body1, Header1 } from "@iventis/styles";
import { Content } from "@iventis/translations";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { CONTACT_URL, SUPPORT_EMAIL } from "@iventis/utilities";
import { errors } from "@iventis/translations/content/errors";
import React from "react";
import { ButtonContainer, StyledButton, StyledErrorImage, StyledLink } from "./error-boundary-styles";

export const ErrorBoundaryObjectDetails = () => {
    const translate = useIventisTranslate();
    const theme = useTheme();
    return (
        <Container>
            <StyledErrorImage strokeColor={theme.typographyColors.blank} secondaryColor={theme.typographyColors.blank} fill="transparent" />
            <Header>{translate(Content.errors.error_boundaries.title_large)}</Header>
            <Body1>
                {translate(Content.errors.error_boundaries.error_message)}
                <StyledLink href={`mailto:${SUPPORT_EMAIL}?subject=Iventis Error`}>{SUPPORT_EMAIL}</StyledLink>
            </Body1>
            <ButtonContainer>
                <ContactUsButton href={CONTACT_URL} variant="outlined">
                    {translate(Content.errors.error_boundaries.contact)}
                </ContactUsButton>
                <StyledButton onClick={() => window.location.reload()}>{translate(errors.error_boundaries.refresh)}</StyledButton>
            </ButtonContainer>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 10px;
    box-sizing: border-box;

    text-align: center;

    max-height: 100%;
    width: 100%;
    background-color: ${({ theme }: { theme: Theme }) => theme.primaryColors.subdued50};
    color: ${({ theme }) => theme.typographyColors.blank};
`;

const ContactUsButton = styled(StyledButton)`
    color: ${({ theme }) => theme.typographyColors.blank};
    border-color: ${({ theme }) => theme.typographyColors.blank};
`;

const Header = styled(Header1)`
    color: ${({ theme }) => theme.typographyColors.blank};
    font-weight: 600;
`;
